module.exports = __webpack_public_path__ + "img/logo_new.c9edf86a.png";